import { render, staticRenderFns } from "./DepositDetailFooter.vue?vue&type=template&id=db33ba7c&"
import script from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports